import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import HorizontalDivider from '../common/HorizontalDivider';
import BillItem from './BillItem';
import BillSummary from './BillSummary';
import { toggleItem } from '../../redux/reducer/slice';

const BillTable = ({ billData, isPayingPerItem = false }) => {
  const [totalGrossAmount, setTotalGrossAmount] = useState(0);
  const [totalNetAmount, setTotalNetAmount] = useState(0);
  const dispatch = useDispatch();
  const selectedItems = useSelector((state) => state.app.selectedItems);

  const getAmount = (item, key) => item?.amount?.[key] ?? item?.amount?.amount ?? 0;

  useEffect(() => {
    const selectedBillData = selectedItems.length > 0
      ? billData.filter((data) => selectedItems.includes(data.id))
      : billData;

    setTotalNetAmount(selectedBillData.reduce((total, item) => total + getAmount(item, 'netAmount'), 0));
    setTotalGrossAmount(selectedBillData.reduce((total, item) => total + getAmount(item, 'grossAmount'), 0));
  }, [billData, selectedItems]);

  const handleCheckboxChange = (id) => {
    dispatch(toggleItem({ id }));
  };

  if (billData && billData.length === 0) {
    // TODO: check that every item is paid for
    // User may have used "Pay per item"
    return <p>You have no outstanding bill items.</p>;
  }

  const setLabel = (serviceType, name, quantity) => {
    const label = serviceType === 'Other' || serviceType === undefined ? name : serviceType;
    return quantity ? `${label} (x${quantity})` : label;
  };
  return (
    <div className="flex w-full flex-col gap-8">
      {/* Bill Table */}
      <div>
        <div className="flex gap-4 font-semibold">
          <div className="flex flex-col xxs:flex-row">
            <span className="ml-14 text-pj-gray-750">Date</span>
            <span className="ml-14">Item Description</span>
          </div>
          <span className="ml-auto">Total (€)</span>
        </div>
        <HorizontalDivider />
        <div className="flex flex-col gap-3">
          {billData
            && billData.map(
              ({
                id, serviceType, amount, name, serviceDate, isPosted, quantity,
              }) => (
                <BillItem
                  key={id}
                  id={id}
                  label={setLabel(serviceType, name, quantity)}
                  date={serviceDate}
                  price={amount.grossAmount ? amount.grossAmount : amount.amount}
                  showCheckbox={isPosted ? isPayingPerItem : false}
                  isPosted={isPosted}
                  isPayingPerItem={isPayingPerItem}
                  isSelected={selectedItems.includes(id)}
                  breakdown={
                    serviceType === 'Other'
                      ? []
                      : [
                        {
                          id,
                          label: name,
                          unitPrice: amount.netAmount ? amount.netAmount : amount.amount,
                        },
                      ]
                  }
                  toggleItemIsSelected={(id) => handleCheckboxChange(id)}
                />
              ),
            )}
        </div>
      </div>

      {/* Total */}
      <div className="ml-auto mt-6 w-5/6">
        <HorizontalDivider />
        <BillSummary
          totalNetAmount={totalNetAmount}
          totalGrossAmount={totalGrossAmount}
        />
      </div>
    </div>
  );
};

BillTable.propTypes = {
  billData: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any)).isRequired,
  isPayingPerItem: PropTypes.bool,
};

export default BillTable;
